import { Typography as TypographyMui, TypographyProps } from "@mui/material";
import classes from "./styles.module.scss";
import clsx from "clsx";

interface Props extends TypographyProps {
  fsz?: number;
  fw?: number;
}

export const Typography = ({
  children,
  className,
  fsz,
  fw,
  ...props
}: Props) => {
  return (
    <TypographyMui
      className={clsx(classes.text, className)}
      style={{ fontSize: fsz, fontWeight: fw }}
      {...props}
    >
      {children}
    </TypographyMui>
  );
};

Typography.Title = ({ children, className, ...props }: Props) => {
  return (
    <Typography
      variant="h1"
      className={clsx(classes.title, className)}
      {...props}
    >
      {children}
    </Typography>
  );
};
